import { AssociateTeamWithVaultRequestEntry } from "./AssociateTeamWithVaultRequestEntry";

export class AssociateTeamsWithVaultRequest {
    vaultId: string;
    entries: AssociateTeamWithVaultRequestEntry[] = [];
}